/**
 * sco design system — primitive color tokens.
 * Source of truth. Edit directly.
 */

import { defineTokens } from '@chakra-ui/react'

export const colors = defineTokens.colors({
  transparent: {
    value: 'transparent',
  },
  current: {
    value: 'currentColor',
  },
  black: {
    value: '#09090B',
  },
  white: {
    value: '#FFFFFF',
  },
  whiteAlpha: {
    '0': {
      value: '#ffffff',
    },
    '50': {
      value: 'rgba(255, 255, 255, 0.0500)',
    },
    '100': {
      value: 'rgba(255, 255, 255, 0.1000)',
    },
    '200': {
      value: 'rgba(255, 255, 255, 0.2000)',
    },
    '300': {
      value: 'rgba(255, 255, 255, 0.3000)',
    },
    '400': {
      value: 'rgba(255, 255, 255, 0.4000)',
    },
    '500': {
      value: 'rgba(255, 255, 255, 0.5000)',
    },
    '600': {
      value: 'rgba(255, 255, 255, 0.6000)',
    },
    '700': {
      value: 'rgba(255, 255, 255, 0.7000)',
    },
    '800': {
      value: 'rgba(255, 255, 255, 0.8000)',
    },
    '900': {
      value: 'rgba(255, 255, 255, 0.9000)',
    },
    '950': {
      value: 'rgba(255, 255, 255, 0.9500)',
    },
  },
  blackAlpha: {
    '0': {
      value: '#000000',
    },
    '50': {
      value: 'rgba(0, 0, 0, 0.0500)',
    },
    '100': {
      value: 'rgba(0, 0, 0, 0.1000)',
    },
    '200': {
      value: 'rgba(0, 0, 0, 0.2000)',
    },
    '300': {
      value: 'rgba(0, 0, 0, 0.3000)',
    },
    '400': {
      value: 'rgba(0, 0, 0, 0.4000)',
    },
    '500': {
      value: 'rgba(0, 0, 0, 0.5000)',
    },
    '600': {
      value: 'rgba(0, 0, 0, 0.6000)',
    },
    '700': {
      value: 'rgba(0, 0, 0, 0.7000)',
    },
    '800': {
      value: 'rgba(0, 0, 0, 0.8000)',
    },
    '900': {
      value: 'rgba(0, 0, 0, 0.9000)',
    },
    '950': {
      value: 'rgba(0, 0, 0, 0.9500)',
    },
  },
  gray: {
    '50': {
      value: '#fafafa',
    },
    '100': {
      value: '#f4f4f5',
    },
    '200': {
      value: '#e4e4e7',
    },
    '300': {
      value: '#d4d4d8',
    },
    '400': {
      value: '#a1a1aa',
    },
    '500': {
      value: '#71717a',
    },
    '600': {
      value: '#52525b',
    },
    '700': {
      value: '#3f3f46',
    },
    '800': {
      value: '#27272a',
    },
    '900': {
      value: '#18181b',
    },
    '950': {
      value: '#111111',
    },
  },
  red: {
    '50': {
      value: '#fef2f2',
    },
    '100': {
      value: '#fee2e2',
    },
    '200': {
      value: '#fecaca',
    },
    '300': {
      value: '#fca5a5',
    },
    '400': {
      value: '#f87171',
    },
    '500': {
      value: '#ef4444',
    },
    '600': {
      value: '#dc2626',
    },
    '700': {
      value: '#991919',
    },
    '800': {
      value: '#511111',
    },
    '900': {
      value: '#300c0c',
    },
    '950': {
      value: '#1f0808',
    },
  },
  pink: {
    '50': {
      value: '#fdf2f8',
    },
    '100': {
      value: '#fce7f3',
    },
    '200': {
      value: '#fbcfe8',
    },
    '300': {
      value: '#f9a8d4',
    },
    '400': {
      value: '#f472b6',
    },
    '500': {
      value: '#ec4899',
    },
    '600': {
      value: '#db2777',
    },
    '700': {
      value: '#a41752',
    },
    '800': {
      value: '#6d0e34',
    },
    '900': {
      value: '#45061f',
    },
    '950': {
      value: '#2c0514',
    },
  },
  purple: {
    '50': {
      value: '#faf5ff',
    },
    '100': {
      value: '#f3e8ff',
    },
    '200': {
      value: '#d5d4ff',
    },
    '300': {
      value: '#bdbbff',
    },
    '400': {
      value: '#9a97ff',
    },
    '500': {
      value: '#6d5de6',
    },
    '600': {
      value: '#4a47a3',
    },
    '700': {
      value: '#54538a',
    },
    '800': {
      value: '#262539',
    },
    '900': {
      value: '#1b1a28',
    },
    '950': {
      value: '#13121c',
    },
  },
  cyan: {
    '50': {
      value: '#ecfeff',
    },
    '100': {
      value: '#cffafe',
    },
    '200': {
      value: '#a5f3fc',
    },
    '300': {
      value: '#67e8f9',
    },
    '400': {
      value: '#22d3ee',
    },
    '500': {
      value: '#06b6d4',
    },
    '600': {
      value: '#0891b2',
    },
    '700': {
      value: '#0c5c72',
    },
    '800': {
      value: '#134152',
    },
    '900': {
      value: '#072a38',
    },
    '950': {
      value: '#051b24',
    },
  },
  blue: {
    '50': {
      value: '#eff6ff',
    },
    '100': {
      value: '#dbeafe',
    },
    '200': {
      value: '#bfdbfe',
    },
    '300': {
      value: '#a3cfff',
    },
    '400': {
      value: '#60a5fa',
    },
    '500': {
      value: '#3b82f6',
    },
    '600': {
      value: '#2563eb',
    },
    '700': {
      value: '#173da6',
    },
    '800': {
      value: '#1a3478',
    },
    '900': {
      value: '#14204a',
    },
    '950': {
      value: '#0c142e',
    },
  },
  teal: {
    '50': {
      value: '#f0fdfa',
    },
    '100': {
      value: '#ccfbf1',
    },
    '200': {
      value: '#99f6e4',
    },
    '300': {
      value: '#5eead4',
    },
    '400': {
      value: '#2dd4bf',
    },
    '500': {
      value: '#14b8a6',
    },
    '600': {
      value: '#0d9488',
    },
    '700': {
      value: '#0c5d56',
    },
    '800': {
      value: '#114240',
    },
    '900': {
      value: '#032726',
    },
    '950': {
      value: '#021716',
    },
  },
  green: {
    '50': {
      value: '#f0fdf4',
    },
    '100': {
      value: '#dcfce7',
    },
    '200': {
      value: '#bbf7d0',
    },
    '300': {
      value: '#86efac',
    },
    '400': {
      value: '#4ade80',
    },
    '500': {
      value: '#22c55e',
    },
    '600': {
      value: '#16a34a',
    },
    '700': {
      value: '#116932',
    },
    '800': {
      value: '#124a28',
    },
    '900': {
      value: '#042713',
    },
    '950': {
      value: '#03190c',
    },
  },
  yellow: {
    '50': {
      value: '#fefce8',
    },
    '100': {
      value: '#fef9c3',
    },
    '200': {
      value: '#fef08a',
    },
    '300': {
      value: '#fde047',
    },
    '400': {
      value: '#facc15',
    },
    '500': {
      value: '#ef901d',
    },
    '600': {
      value: '#ca8a04',
    },
    '700': {
      value: '#845209',
    },
    '800': {
      value: '#713f12',
    },
    '900': {
      value: '#422006',
    },
    '950': {
      value: '#281304',
    },
  },
  primary: {
    value: 'rgb(95, 116, 149)',
  },
  primaryAlpha: {
    '50': { value: 'rgba(95, 116, 149, 0.05)' },
    '100': { value: 'rgba(95, 116, 149, 0.1)' },
    '200': { value: 'rgba(95, 116, 149, 0.2)' },
    '300': { value: 'rgba(95, 116, 149, 0.3)' },
    '400': { value: 'rgba(95, 116, 149, 0.4)' },
    '500': { value: 'rgba(95, 116, 149, 0.5)' },
    '600': { value: 'rgba(95, 116, 149, 0.6)' },
    '700': { value: 'rgba(95, 116, 149, 0.7)' },
    '800': { value: 'rgba(95, 116, 149, 0.8)' },
    '900': { value: 'rgba(95, 116, 149, 0.9)' },
  },
  actionPrimary: {
    value: 'rgb(175, 197, 232)',
  },
  actionPrimaryAlpha: {
    '50': { value: 'rgba(175, 197, 232, 0.05)' },
    '100': { value: 'rgba(175, 197, 232, 0.1)' },
    '200': { value: 'rgba(175, 197, 232, 0.2)' },
    '300': { value: 'rgba(175, 197, 232, 0.3)' },
    '400': { value: 'rgba(175, 197, 232, 0.4)' },
    '500': { value: 'rgba(175, 197, 232, 0.5)' },
    '600': { value: 'rgba(175, 197, 232, 0.6)' },
    '700': { value: 'rgba(175, 197, 232, 0.7)' },
    '800': { value: 'rgba(175, 197, 232, 0.8)' },
    '900': { value: 'rgba(175, 197, 232, 0.9)' },
  },
  actionActive: {
    value: 'rgb(239, 144, 29)',
  },
  actionActiveAlpha: {
    '50': { value: 'rgba(239, 144, 29, 0.05)' },
    '100': { value: 'rgba(239, 144, 29, 0.1)' },
    '200': { value: 'rgba(239, 144, 29, 0.2)' },
    '300': { value: 'rgba(239, 144, 29, 0.3)' },
    '400': { value: 'rgba(239, 144, 29, 0.4)' },
    '500': { value: 'rgba(239, 144, 29, 0.5)' },
    '600': { value: 'rgba(239, 144, 29, 0.6)' },
    '700': { value: 'rgba(239, 144, 29, 0.7)' },
    '800': { value: 'rgba(239, 144, 29, 0.8)' },
    '900': { value: 'rgba(239, 144, 29, 0.9)' },
  },
  actionActiveSecondary: {
    value: 'rgb(74, 71, 163)',
  },
  actionActiveSecondaryAlpha: {
    '50': { value: 'rgba(74, 71, 163, 0.05)' },
    '100': { value: 'rgba(74, 71, 163, 0.1)' },
    '200': { value: 'rgba(74, 71, 163, 0.2)' },
    '300': { value: 'rgba(74, 71, 163, 0.3)' },
    '400': { value: 'rgba(74, 71, 163, 0.4)' },
    '500': { value: 'rgba(74, 71, 163, 0.5)' },
    '600': { value: 'rgba(74, 71, 163, 0.6)' },
    '700': { value: 'rgba(74, 71, 163, 0.7)' },
    '800': { value: 'rgba(74, 71, 163, 0.8)' },
    '900': { value: 'rgba(74, 71, 163, 0.9)' },
  },
  orange: {
    '50': {
      value: '#fff7ed',
    },
    '100': {
      value: '#ffedd5',
    },
    '200': {
      value: '#fed7aa',
    },
    '300': {
      value: '#fdba74',
    },
    '400': {
      value: '#fb923c',
    },
    '500': {
      value: '#f97316',
    },
    '600': {
      value: '#ea580c',
    },
    '700': {
      value: '#c2410c',
    },
    '800': {
      value: '#6c2710',
    },
    '900': {
      value: '#3b1106',
    },
    '950': {
      value: '#220a04',
    },
  },
})
